import React, { FC, ReactNode } from 'react';
import { useFormContext } from 'react-hook-form';

import type { BoxProps } from '@mantine/core';
import { Alert, Stack, Text } from '@mantine/core';
import { crush } from 'radash';

const FormStatus: FC<{ successMessage?: ReactNode; showValidationErrors?: boolean } & BoxProps> = ({
    successMessage,
    showValidationErrors,
    ...props
}) => {
    const {
        formState: { errors, isSubmitSuccessful },
    } = useFormContext();

    const children = [];

    const hasValidationErrors = Object.keys(errors).length > 0;

    if (showValidationErrors && hasValidationErrors) {
        children.push(
            <Alert color="red">
                {Object.entries(crush(errors)).map(([key, value]) =>
                    key.includes('.message') ? <Text key={key} inherit children={value} /> : null,
                )}
            </Alert>,
        );
    }

    if (errors?.root?.submitError) {
        children.push(<Alert color="red" title={errors.root.submitError?.message} />);
    }

    if (isSubmitSuccessful && successMessage) {
        children.push(<Alert color="green">{successMessage}</Alert>);
    }

    return children.length ? (
        <Stack gap="xs" {...props}>
            {children}
        </Stack>
    ) : null;
};

export { FormStatus };
